(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-account-entry"] && !Shopify.designMode) return;
  try {
    
  // Account-entry gallery: crossfade plates on a timer, pause on hover/focus and
  // when the tab is hidden, and let the dots take over on click. Entirely
  // progressive — with JS off the first plate simply stays put.
  (function () {
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initGallery(root) {
      var plates = root.querySelectorAll('[data-bf-plate]');
      var dots = root.querySelectorAll('[data-bf-dot]');
      if (plates.length < 2) return;

      var i = 0;
      var timer = null;
      var delay = (parseFloat(root.getAttribute('data-interval')) || 5) * 1000;

      function show(n) {
        i = (n + plates.length) % plates.length;
        for (var p = 0; p < plates.length; p++) {
          var on = p === i;
          plates[p].classList.toggle('is-active', on);
          if (on) plates[p].removeAttribute('aria-hidden');
          else plates[p].setAttribute('aria-hidden', 'true');
        }
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('is-active', d === i);
          dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
        }
      }

      function start() {
        if (REDUCED || timer) return;
        timer = setInterval(function () { show(i + 1); }, delay);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      for (var d = 0; d < dots.length; d++) {
        (function (n) {
          dots[n].addEventListener('click', function () { stop(); show(n); start(); });
        })(d);
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      start();
    }

    function initSection(section) {
      var gallery = section.querySelector('[data-bf-gallery]');
      if (gallery) initGallery(gallery);

      // Stagger the copy in once the section is on screen.
      if (!('IntersectionObserver' in window)) { section.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) {
            entries[e].target.classList.add('is-in');
            io.unobserve(entries[e].target);
          }
        }
      }, { threshold: 0.15 });
      io.observe(section);
    }

    function boot(scope) {
      var sections = (scope || document).querySelectorAll('[data-bf-acctentry]');
      for (var s = 0; s < sections.length; s++) initSection(sections[s]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    // Theme editor re-renders the section on every setting change.
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-footer"] && !Shopify.designMode) return;
  try {
    
  /* Newsletter form: branded, accessible validation + double-submit guard.
     Progressive enhancement — with JS off, the native required/type=email
     validation still fires, so the form is never left without feedback. */
  (function () {
    function init(form) {
      if (form._bfNews) return;
      form._bfNews = true;
      var email = form.querySelector('input[type="email"]');
      var msg = form.querySelector('.bf-footer__form-err');
      var ok = form.querySelector('.bf-footer__form-ok');
      var btn = form.querySelector('button[type="submit"]');
      if (!email) return;

      /* Shopify's own action carries a #contact_form fragment, so the post-POST
         redirect yanks the page down to the footer. Nothing is sent to the server
         after the '#', so dropping it costs nothing and kills the jump on the
         no-JS path too. */
      var action = form.getAttribute('action') || '/contact';
      form.setAttribute('action', action.split('#')[0]);
      // Take over validation from the browser so errors are branded + styleable.
      form.setAttribute('novalidate', 'novalidate');
      var submitting = false;
      var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      function showError(text) {
        email.setAttribute('aria-invalid', 'true');
        if (msg) { msg.textContent = text; msg.hidden = false; }
      }
      function clearError() {
        email.removeAttribute('aria-invalid');
        if (msg) { msg.hidden = true; msg.textContent = ''; }
      }
      email.addEventListener('input', clearError);

      // Release the busy lock. Called on any route that leaves the visitor still
      // looking at this form, so the button can never be permanently dead.
      var stuckTimer = null;
      function release() {
        submitting = false;
        if (stuckTimer) { clearTimeout(stuckTimer); stuckTimer = null; }
        if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
      }

      form.addEventListener('submit', function (e) {
        // Block repeat submits while the first POST is in flight (dupe records).
        if (submitting) { e.preventDefault(); return; }
        var v = (email.value || '').trim();
        if (!v) { e.preventDefault(); showError('Please enter your email address.'); email.focus(); return; }
        if (!EMAIL.test(v)) { e.preventDefault(); showError('Please enter a valid email address.'); email.focus(); return; }
        clearError();
        submitting = true;
        if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }

        /* Post in the background and render the result inline. Guarded on the
           APIs actually used, so anything older falls through to the native
           navigating POST rather than silently dropping the signup.

           Note: Shopify's invisible hCaptcha wraps the *native* submit. We only
           take this path when no captcha wrapper is present on the form; when it
           is, the native submit runs untouched so the challenge still solves. */
        var canAjax = window.fetch && window.FormData && window.Promise &&
                      !form.querySelector('[data-hcaptcha-widget-id], .h-captcha, iframe[src*="hcaptcha"]');
        if (canAjax && ok) {
          e.preventDefault();
          fetch(form.getAttribute('action'), {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' },
            credentials: 'same-origin'
          }).then(function (res) {
            // Shopify signals a stored signup by redirecting to ?customer_posted=true.
            if (res.ok && /customer_posted=true/.test(res.url)) {
              ok.textContent = 'Thank you — you’re on the list.';
              ok.hidden = false;
              email.hidden = true;
              if (btn) btn.hidden = true;
              release();
            } else {
              // Reached the server but the outcome is unclear — hand the visitor
              // back to the native POST rather than claim a success we can't see.
              release();
              form.submit();
            }
          }).catch(function () {
            release();
            form.submit();
          });
          return;
        }

        /* The native POST normally navigates away and this page is discarded.
           If it does NOT — blocked request, dropped connection, offline — we are
           still here holding submitting=true, and .is-busy sets
           `pointer-events: none`, so the button becomes permanently unclickable
           with no message. The visitor cannot subscribe and is told nothing.
           This watchdog releases the lock and surfaces the failure instead.

           20s, not a snappier number, on purpose: Shopify wraps storefront forms
           in an invisible hCaptcha challenge
           (shopifycloud/storefront-forms-hcaptcha) that holds the submit, solves,
           then re-submits. On a slow connection that can take many seconds, and
           firing early would flash a false error mid-challenge. This is a
           last-resort unstick, not a latency check. */
        stuckTimer = setTimeout(function () {
          release();
          showError('Something went wrong — please try again.');
        }, 20000);
      });

      // Fires for bfcache restores (evt.persisted) AND ordinary loads, so a
      // visitor returning to this page never finds a locked button.
      window.addEventListener('pageshow', release);
    }
    function boot() {
      var forms = document.querySelectorAll('.bf-footer__form');
      for (var i = 0; i < forms.length; i++) init(forms[i]);
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-header"]) return;
  try {
    
  /* The header cart count is rendered server-side, so without this it stays at whatever
     it was on page load — add to cart appeared to do nothing. Horizon keeps its own
     <cart-icon> element in sync via the storefront standard event; this header is custom,
     so it listens for the same event. */
  (function () {
    var EVENT = 'shopify:cart:lines-update';

    function paint(count) {
      var n = Number(count) || 0;

      var els = document.querySelectorAll('[data-bf-cart-count]');
      for (var i = 0; i < els.length; i++) els[i].textContent = String(n);

      var badges = document.querySelectorAll('[data-bf-cart-badge]');
      for (var j = 0; j < badges.length; j++) {
        badges[j].textContent = n > 99 ? '99+' : String(n);
        badges[j].hidden = n === 0;
      }

      var links = document.querySelectorAll('[data-bf-cart-link]');
      for (var k = 0; k < links.length; k++) {
        links[k].setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
      }
    }

    document.addEventListener(EVENT, function (event) {
      /* The event fires optimistically; `promise` settles with the real cart. */
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise
          .then(function (result) {
            var cart = result && result.cart;
            var detail = result && result.detail;
            var count = (cart && cart.totalQuantity) != null
              ? cart.totalQuantity
              : (detail && detail.itemCount) || 0;
            paint(count);
          })
          .catch(function () {
            /* Add failed — re-read so the badge never shows a phantom item. */
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (c) { paint(c.item_count); })
              .catch(function () {});
          });
      }
    });

    /* The bag icon is a real <a href="/cart"> so it still works without JS, in a new
       tab, and on the cart page itself. When the drawer is available, open that instead
       of doing a full page load — cart_type is set to "drawer", so navigating away was
       inconsistent with how add-to-cart behaves. */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-bf-cart-link]');
      if (!link) return;

      /* Let the browser handle new-tab / new-window / download intents. */
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      /* On /cart the drawer would just duplicate the page. */
      if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) return;

      var drawer = document.getElementById('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;

      event.preventDefault();
      drawer.open();
    });

    /* Back/forward cache restores a stale header. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count); })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
